import sortBy from 'lodash/sortBy';
import includes from 'lodash/includes';
import {
  // getItemPriceForSpecialDiscount,
  detectMergeRequired,
  getItemPrice,
} from './utilities';

export const getLoyaltyDiscount = (
  currentOrder,
  rowItems,
  offers,
  pathwayToOffers,
  itemsUsedForReward,
  rewards,
  halfHalfSetup
) => {
  let { offerFrames } = detectOffers(
    currentOrder,
    rowItems,
    offers,
    pathwayToOffers,
    itemsUsedForReward,
    halfHalfSetup
  );
  offerFrames.forEach((p) => {
    rewards = [...rewards, ...p.rewards];
  });
  let discount = rewards.reduce(
    (total, obj) => (total = total + Number(obj.discount)),
    0
  );

  return discount;
};

export function detectOffers(
  currentOrder,
  rowItems,
  offers,
  pathwayToOffers,
  itemsUsedForReward,
  halfHalfSetup
) {
  let rawOfferFrames = getOfferFrames(offers, pathwayToOffers);
  let offerFrames = [];
  let itemsUsedForOfferDetection = [];
  // let itemsUsedForReward = [];

  if (rawOfferFrames?.length) {
    let itemsUsedFrames = [];
    rawOfferFrames.forEach((offerFrame) => {
      if (offerFrame.type === '1') {
        let matchingRowItems = rowItems.filter(
          (rowItem) =>
            offerFrame.activeCategoryKeys?.includes(rowItem.categoryId) &&
            (offerFrame.activeSizeKeys?.includes(rowItem.sizeKey) ||
              offerFrame.activeModifierKeys?.includes(rowItem.sizeKey)) &&
            offerFrame.activeMenuItemKeys?.includes(rowItem._id) &&
            !itemsUsedFrames.includes(rowItem.primaryKey)
        );
        let count = 0;
        matchingRowItems.forEach((rowItem) => {
          count = count + (rowItem.isHalf ? 0.5 : 1);
        });
        offerFrame.totalOrderCount = offerFrame.orderCount + count;
        offerFrame.matchingRowItems = matchingRowItems;
      } else {
        offerFrame.totalOrderCount =
          Number(offerFrame.orderCount) > Number(offerFrame.noOfOrders)
            ? Number(offerFrame.noOfOrders) || 1
            : Number(offerFrame.orderCount);
        offerFrame.matchingRowItems = [];
      }
    });
  }
  rawOfferFrames = rawOfferFrames.filter(
    (offer) =>
      offer.totalOrderCount >=
      (offer.type === '1' ? Number(offer.quantity) : Number(offer.noOfOrders))
  );
  rawOfferFrames.forEach((offer) => {
    let leftQauntity = Number(offer.orderCount);
    if (offer.type === '1') {
      for (let j = 0; Number(offer.quantity) * j < offer.totalOrderCount; j++) {
        let iNeedQuantityFromCart = 0;
        let obj = { ...offer };
        let numPush =
          Number(offer.quantity) * (j + 1) <= offer.totalOrderCount
            ? Number(offer.quantity)
            : offer.totalOrderCount - Number(offer.quantity) * j;
        if (numPush >= Number(offer.quantity)) {
          if (leftQauntity <= 0) {
            iNeedQuantityFromCart = numPush;
          } else if (leftQauntity < numPush && leftQauntity > 0) {
            iNeedQuantityFromCart = numPush - leftQauntity;
          }
          if (numPush >= leftQauntity) {
            leftQauntity = 0;
          } else {
            leftQauntity = leftQauntity - numPush;
          }
          let useItems = [];
          offer.matchingRowItems.forEach((p) => {
            if (
              !itemsUsedForOfferDetection.includes(p.primaryKey) &&
              !itemsUsedForReward.includes(p.primaryKey) &&
              useItems.length < iNeedQuantityFromCart
            ) {
              useItems.push(p);
            }
          });
          if (iNeedQuantityFromCart === useItems.length) {
            obj.iNeedQuantityFromCart = iNeedQuantityFromCart;
            obj.itemsUsed = useItems;
            itemsUsedForOfferDetection = [
              ...itemsUsedForOfferDetection,
              ...useItems.map((p) => p.primaryKey),
            ];
            delete obj.matchingRowItems;
            let rewardFrames = getRewardFrame(obj);
            let rewardForOffer = detectReward(
              offers,
              currentOrder,
              rowItems,
              rewardFrames,
              itemsUsedForOfferDetection,
              itemsUsedForReward,
              halfHalfSetup
            );
            obj.rewards = rewardForOffer;
            offerFrames.push(obj);
          }
        }
      }
    } else if (Number(offer.noOfOrders) >= 0) {
      for (
        let j = 0;
        (Number(offer.noOfOrders) || 1) * j < offer.totalOrderCount;
        j++
      ) {
        let obj = { ...offer };
        let numPush =
          Number(offer.noOfOrders) * (j + 1) <= offer.totalOrderCount
            ? Number(offer.noOfOrders)
            : offer.totalOrderCount - Number(offer.noOfOrders) * j;
        if (numPush >= Number(offer.noOfOrders)) {
          if (numPush >= leftQauntity) {
            leftQauntity = 0;
          } else {
            leftQauntity = leftQauntity - numPush;
          }
          let rewardFrames = getRewardFrame(obj);
          let rewardForOffer = detectReward(
            offers,
            currentOrder,
            rowItems,
            rewardFrames,
            itemsUsedForOfferDetection,
            itemsUsedForReward,
            halfHalfSetup
          );
          obj.rewards = rewardForOffer;
          offerFrames.push(obj);
        }
      }
    }
  });
  return { offerFrames, itemsUsedForReward };
}

export function getOfferFrames(offers, pathwayToOffers) {
  let rawOfferFrames = [];
  if (offers && pathwayToOffers) {
    rawOfferFrames = offers.map((offer) => {
      let matchingProgress = pathwayToOffers.filter(
        (path) => path.offerId === offer._id
      );
      if (matchingProgress.length > 0) {
        let count = matchingProgress.reduce(
          (total, item) => total + item.orderCount,
          0
        );
        offer.orderCount = count;
      } else {
        offer.orderCount = 0;
      }
      return offer;
    });
  }
  return rawOfferFrames;
}

export function getRewardFrame(offer) {
  let rewardFrames = [];
  let x = {
    _id: offer._id,
    name: offer.name,
    isComplete: false,
    slots: [],
    isAnyOneItemAvailable: offer.isAnyOneItemAvailable,
  };

  offer.rewardItems?.forEach((sp) => {
    new Array(Number(sp.quantity)).fill().forEach((_m, i) => {
      let u = {
        categoryKeys: sp.categories.filter((s) => s.isActive).map((s) => s._id),
        sizeKeys: sp.sizes
          ? sp.sizes.filter((s) => s.isActive).map((s) => s._id)
          : [],
        modifierKeys: sp.subModifiers
          ? sp.subModifiers.filter((s) => s.isActive).map((s) => s._id)
          : [],
        menuItems: sp.menuItems.filter((s) => !s.isActive).map((s) => s._id),
        id: i + 1,
        isSlotOccupied: false,
      };
      x.slots.push(u);
    });
  });
  x.slotLength = x.slots.length;
  rewardFrames.push(x);
  return rewardFrames;
}

// TODO: Need to implement what ever is in customer website
export function detectReward(
  offers,
  currentOrder,
  rowItems,
  rewardFrames,
  itemsUsedForOfferDetection,
  itemsUsedForReward,
  halfHalfSetup
) {
  const rewardItemsObj = [];
  let rewards = [];
  if (rowItems && rowItems.length > 0 && rewardFrames.length > 0) {
    rewardFrames = sortBy(rewardFrames, 'slotLength').reverse();
    rewardFrames.forEach((s) => {
      getRewardDetectionCount(
        s,
        rowItems,
        itemsUsedForReward,
        itemsUsedForOfferDetection,
        rewardItemsObj
      );
    });

    rewardItemsObj?.forEach((sd) => {
      let itemsToBeAddedInOffer = [];
      sd.slots.forEach((ss) => {
        let rowMenuItems = JSON.parse(JSON.stringify(currentOrder.menuItems));
        let filteredItem = [];

        // Can Try => ff._id === ss.itemId
        filteredItem = rowMenuItems?.filter(
          (ff) => ff._id === ss.itemId && ss.orderIndex === ff.orderIndex
        );

        filteredItem?.forEach((ftmm) => {
          let ttml = ftmm;
          if (detectMergeRequired(ss, ttml)) {
            ttml.selectedSizes = ttml.selectedSizes.filter(
              (ggm) => ss.sizeKeyMatched === ggm._id
            );
            if (ttml.selectedSizes && ttml.selectedSizes.length > 0) {
              ttml.selectedSizes[0].quantity = ttml.isHalf ? 0.5 : 1;
              if (ttml.isHalf) {
                itemsToBeAddedInOffer.push(ttml);
                const otherHalf = ttml.whichHalf === 1 ? 2 : 1;

                let othersHalf = rowMenuItems.filter(
                  (m) =>
                    m.halfIndex === ttml.halfIndex && m.whichHalf === otherHalf
                );
                if (othersHalf.length > 0) {
                  let ttmll = othersHalf[0];
                  ttmll.selectedSizes[0].quantity = 0.5;
                  ttml = { ...ttmll };
                }
              }
              itemsToBeAddedInOffer.push(ttml);
            }
          }
        });
      });

      let matchingOffer = offers.filter((obj) => obj._id === sd._id);
      if (
        itemsToBeAddedInOffer &&
        itemsToBeAddedInOffer.length > 0 &&
        matchingOffer.length > 0
      ) {
        let matchedOffer = matchingOffer[0];
        let discountedPrice = 0;
        if (sd.isAnyOneItemAvailable) {
          matchedOffer.rewardItems.forEach((obj) => {
            if (
              discountedPrice !== 0 &&
              discountedPrice > Number(obj.discountedPrice)
            )
              discountedPrice = Number(obj.discountedPrice);
            else discountedPrice = Number(obj.discountedPrice);
          });
        } else {
          discountedPrice = matchedOffer.rewardItems.reduce((total, obj) => {
            return (total = total + Number(obj.discountedPrice));
          }, 0);
        }
        let totalCost = 0,
          offerDiscount = 0;
        itemsToBeAddedInOffer?.forEach((m) => {
          let itemPrice = getItemPrice(m, halfHalfSetup, true);
          if (!m?.itemType || m?.itemType === 0) {
            itemPrice = Number(itemPrice);
          } else {
            const itemQuantity = m?.quantity || 1;
            itemPrice = Number(itemPrice) / itemQuantity;
          }
          if (sd.isAnyOneItemAvailable) {
            if (totalCost !== 0 && totalCost < Number(itemPrice))
              totalCost = Number(itemPrice);
            else if (totalCost === 0) totalCost = Number(itemPrice);
          } else totalCost = totalCost + Number(itemPrice);
        });
        offerDiscount = totalCost - Number(discountedPrice);
        let sObj = {
          _id: matchedOffer._id,
          name: matchedOffer.name,
          discount: offerDiscount.toFixed(2),
          slots: sd.slots,
          isComplete: sd.isComplete,
        };
        rewards.push(sObj);
      }
    });
  }
  return rewards;
}

export function getRewardDetectionCount(
  frame,
  rowItems,
  itemsUsedForReward,
  itemsUsedForOfferDetection,
  rewardItemsObj
) {
  let ct = 0;
  let s = JSON.parse(JSON.stringify(frame));
  let itemsUsedForS = [];
  if (s.slots && s.slots.length > 0) {
    s.slots = s.slots.map((i) => {
      let itemExistForMatch = rowItems.filter(
        (r) =>
          i.categoryKeys?.includes(r.categoryId) &&
          (i.sizeKeys?.includes(r.sizeKey) ||
            i.modifierKeys?.includes(r.sizeKey)) &&
          !i.menuItems?.includes(r._id)
      );
      if (itemExistForMatch.length > 0) {
        for (let l = 0; l < itemExistForMatch.length; l++) {
          if (
            !includes(itemsUsedForS, itemExistForMatch[l].primaryKey) &&
            !includes(itemsUsedForReward, itemExistForMatch[l].primaryKey) &&
            !includes(
              itemsUsedForOfferDetection,
              itemExistForMatch[l].primaryKey
            ) &&
            !i.isSlotOccupied
          ) {
            i.isSlotOccupied = true;
            i.itemId = itemExistForMatch[l]._id;
            i.primaryKey = itemExistForMatch[l].primaryKey;
            i.orderIndex = itemExistForMatch[l].orderIndex;
            i.name = itemExistForMatch[l].name;
            i.isHalf = itemExistForMatch[l].isHalf;
            i.isSecondHalf = itemExistForMatch[l].isSecondHalf;
            i.removedIngredients = itemExistForMatch[l].removedIngredients;
            i.selectedExtraIngredients =
              itemExistForMatch[l].selectedExtraIngredients;
            i.sizeKeyMatched = itemExistForMatch[l].sizeKey;
            itemsUsedForS.push(itemExistForMatch[l].primaryKey);
            ct = ct + 1;
          }
        }
      }
      return i;
    });
    itemsUsedForReward = [...itemsUsedForReward, ...itemsUsedForS];
    rewardItemsObj.push({
      _id: s._id,
      name: s.name,
      slots: s.slots,
      isAnyOneItemAvailable: s.isAnyOneItemAvailable,
      isComplete: ct === s.slots.length,
    });
  }
}
